import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import PortContMain from "presentation/view/container/Port/PortContMain";

CommonEntrypoint(<PortContMain/>)